import React, { Component } from 'react'

export default class LogoutConfirmation extends Component {
    render() {
        return (
<div>
<div>you are now logged out</div>
</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/util/LogoutConfirmation.js